import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {Option} from '../../models/BojaModel'
import {getRoditeljiDropdown} from '../../api'

interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const mapDropdown = (data) => {
  return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
}

const RoditeljiDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [RoditeljiDropdown, setRoditeljiDropdown] = useState<Array<Option>>([])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [internalValue, setInternalValue] = useState<string | number | null>(initialValue ?? null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRoditeljiDropdown()
        setRoditeljiDropdown(mapDropdown(response.data))
      } catch (error) {
        console.error('Error fetching Roditelji dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = typeof value !== 'undefined' ? value : internalValue

  return (
    <SearchableSelect
      options={RoditeljiDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'Roditelji'}
      errors={errors}
      placeholder='Odaberi Roditelja Artikla...'
      touched={touched}
    />
  )
}

export default RoditeljiDropdown
